import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

function firstAvailablePath(user) {
  const perms = user?.permissions || [];
  if (user?.role === "super_admin") return "/super-admin";
  if (perms.includes("dashboard")) return "/admin";
  if (perms.includes("staff")) return "/staff";
  return "/";
}

export function ProtectedRoute({ children, roles, permission }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <div className="text-slate-500 font-heading">Chargement…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (user.must_change_password && location.pathname !== "/force-password") {
    return <Navigate to="/force-password" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={firstAvailablePath(user)} replace />;
  }
  if (permission && user.role !== "super_admin" && !(user.permissions || []).includes(permission)) {
    return <Navigate to={firstAvailablePath(user)} replace />;
  }
  return children;
}

export { firstAvailablePath };
